import  { useState } from 'react'


export const ApplicantsState = () => {
    const [readApList, setReadApList] = useState([])
    const [statSelected, setStatSelected] = useState([])
    const [position, setPosition] = useState([])
    const [listLoader, setListLoader] = useState(true)
    const [posSet, setPosSet] = useState([ {id: 0, position: 'All'}])
    const [open, setOpen] = useState(false)
    const [applicantView, setApplicantView] = useState([])
    const [viewLoader, setViewLoader] = useState(false)
    const [viewPdf, setViewPdf] = useState(false);
    const [remarksData, setRemarksData] = useState ([])
    const [apSched, setApSched] = useState ([])
    const [count, setCount] = useState ([])
    const [inftScroll, setInftScroll] = useState(true)
    const [lid, setLid] = useState()
    const [status , setStatus] = useState([
        {id: 0, name: 'All'},
        {id: 1, name: 'For Initial Interview'},
        {id: 2, name: 'For Final Interview'},
        {id: 3, name: 'For Review'},
        {id: 4, name: 'For Pooling'},
        {id: 5, name: 'Rejected'},
        {id: 6, name: 'Reviewed'},
        {id: 7, name: 'Hired'},
        {id: 8, name: 'Withdrawn'},
    ])

    const [applicantStatus , setApplicantStatus] = useState([
      {id: 1, name: 'For Initial Interview'},
      {id: 2, name: 'For Final Interview'},
      {id: 4, name: 'For Pooling'},
      {id: 5, name: 'Rejected'},
      {id: 6, name: 'Reviewed'},
      {id: 7, name: 'Hired'},
      {id: 8, name: 'Withdrawn'},
  ])

    const [schedModal, setSchedModal] = useState(false)
    const [schedule, setSchedule] = useState ({
      type: "create",
      schedInputs:{
          scheduled_date: {value: '', stat: false, msg: '', toggled: false},
          scheduled_time: {value: '', stat: false, msg: '', toggled: false},
          status: {value: '', stat: false, msg: '', toggled: false},    
      }
  })

  const [remarks, setRemarks] = useState ({
    type:'create',
    inputs:{
        name: {value: '', stat: false, msg: '', toggled: false},
        status: {value: '', stat: false, msg: '', toggled: false},
        applicant_id: {value: '', stat: false, msg: '', toggled: false},
    }
})

const [remarksDefault, setRemarksDefault] = useState([])
const [rmrksBtn, setRmrksBtn] = useState (false)
const [rmksLoader, setRmksLoader] = useState(false)
const [countLoader, setCountLoader] = useState(false)
const [apSearch, setApSearch] =useState('')

  return {
    readApList: {data: readApList, set: setReadApList},
    position: {data: position, set: setPosition},    
    status: {data: status, set: setStatus},
    statSelected: {data: statSelected, set: setStatSelected},
    listLoader: {data: listLoader, set: setListLoader},
    posSet: {data: posSet, set: setPosSet},
    open: {data: open, set: setOpen},
    applicantView: {data: applicantView, set: setApplicantView},
    viewLoader:{data: viewLoader, set: setViewLoader},
    applicantStatus: {data: applicantStatus, set: setApplicantStatus},
    schedModal: {data: schedModal, set: setSchedModal},
    schedule: {data: schedule, set: setSchedule} ,
    viewPdf: {data: viewPdf, set: setViewPdf},
    remarks: {data: remarks, set: setRemarks},
    apSched: {data: apSched, set: setApSched},
    rmrksBtn: {data: rmrksBtn, set: setRmrksBtn},
    remarksData:{data: remarksData, set: setRemarksData},
    rmksLoader: {data: rmksLoader, set: setRmksLoader},
    countLoader: {data: countLoader, set: setCountLoader},
    count: {data: count, set: setCount},
    apSearch: {data: apSearch, set: setApSearch},
    remarksDefault: {data: remarksDefault, set: setRemarksDefault},
    inftScroll:{data: inftScroll, set: setInftScroll}, 
    lid:{data: lid, set: setLid},                     
  }
}
